<template>
    <ProcColumnPanel
        title="Documentação anterior"
        :subtitle="`${documentos.length} registro(s)`"
        :expanded="expanded"
        @toggle-expand="$emit('toggle-expand')"
    >
        <div v-if="documentos.length === 0" class="empty-box">
            Nenhum documento anterior localizado para este processo.
        </div>

        <div
            v-for="doc in documentos"
            :key="`${doc.id}-${doc.idlaudo || doc.idanexo}`"
            class="proc-card"
        >
            <div class="card-main">
                <div class="card-text">
                    <h4>{{ doc.nmitem }}</h4>
                    <div class="proc-header-line">
                        <strong>Inserido por:</strong>
                        <span>{{ doc.nmusuario_inclusao }}</span>
                    </div>
                    <div class="proc-header-line">
                        <strong>Etapa:</strong>
                        <span>{{ doc.nmetapa_inclusao }}</span>
                    </div>
                </div>


                <span :class="['status-pill', statusAnaliseClasse(doc)]">
                    {{ statusAnaliseTexto(doc) }}
                </span>
            </div>

            <div class="tag-row">
                <span class="tag">{{ doc.iddoc ? 'Formulário interno' : 'Anexo externo' }}</span>
                <span v-if="doc.dhavaliacao" class="tag">Analisado em {{ formatarDataHora(doc.dhavaliacao) }}</span>
                <span v-if="doc.nmusuario_avaliacao" class="tag">Analisado por {{ doc.nmusuario_avaliacao }}</span>
                <span v-if="doc.removido_dh" class="tag obrigatorio">Removido</span>
            </div>

            <div v-if="doc.justificativa" class="proc-doc-justificativa">
                {{ doc.justificativa }}
            </div>

            <div class="card-actions">
                <button
                    v-if="doc.idanexo"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('visualizar-anexo', doc.idanexo)"
                >
                    Visualizar
                </button>
                
                <button
                    v-if="doc.idlaudo"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('visualizar-anexo', doc.idlaudo)"
                >
                    Visualizar
                </button>

                <button
                    v-if="podeAnalisar"
                    class="btn-small proc-btn primary"
                    type="button"
                    @click="$emit('analisar', doc)"
                >
                    Analisar
                </button>
            </div>
        </div>
    </ProcColumnPanel>
</template>

<script setup>
import ProcColumnPanel from './ProcColumnPanel.vue';

defineProps({
    documentos: { type: Array, default: () => [] },
    podeAnalisar: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    formatarDataHora: { type: Function, required: true },
    statusAnaliseTexto: { type: Function, required: true },
    statusAnaliseClasse: { type: Function, required: true },
});

defineEmits(['visualizar-anexo', 'analisar', 'toggle-expand']);
</script>
